/**
 * PromotionListContainer
 * --
 */
import React from 'react';
import PromotionListPresenter from './PromotionListPresenter';

const PromotionListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <PromotionListPresenter />
    </>
  );
};

export default PromotionListContainer;
